window.onresize = resituaDisplays;
function resituaDisplays() {
  if (document.getElementById("video1Loop").style.display == "none") {
    var anchoVideo = document.getElementById("video1").offsetWidth;
    //document.getElementById('anchoVideoDisplay').innerHTML = anchoVideo

    var altoVideo = document.getElementById("video1").offsetHeight;
    //document.getElementById('altoVideoDisplay').innerHTML = altoVideo
  } else {
    var anchoVideo = document.getElementById("video1Loop").offsetWidth;
    //document.getElementById('anchoVideoDisplay').innerHTML = anchoVideo

    var altoVideo = document.getElementById("video1Loop").offsetHeight;
    //document.getElementById('altoVideoDisplay').innerHTML = altoVideo
  }

  if (anchoVideo === 0 && altoVideo === 0) {
    return;
  }

  document.getElementById("video1LoopTraditionalCount").style.left =
    parseInt(anchoVideo * 0.3) + "px";
  document.getElementById("video1LoopTraditionalCount").style.top =
    parseInt(altoVideo * 0.67) + "px";
  document.getElementById("video1LoopTraditionalCount").style.display =
    "inline";
  document.getElementById("video1LoopTraditionalCount").style.fontSize =
    anchoVideo / 1200 + "em";

  document.getElementById("video1LoopBufferCount").style.left =
    parseInt(anchoVideo * 0.33) + "px";
  document.getElementById("video1LoopBufferCount").style.top =
    parseInt(altoVideo * 0.88) + "px";
  document.getElementById("video1LoopBufferCount").style.display = "inline";
  document.getElementById("video1LoopBufferCount").style.fontSize =
    anchoVideo / 700 + "em";
}

// window.onload = reorderTeam;
// function reorderTeam() {
//   const team = document.getElementById("team");
//   const people = team.childNodes;
//   const size = people.length;
//   for (const elem of people) {
//     if (elem.nodeType == Node.ELEMENT_NODE) {
//       elem.style.order = parseInt(Math.random() * size);
//     }
//   }
//   team.style.display = "flex";
// }

const counterRequest = {
  traditional: {
    real: 1,
    mock: 1
  },
  buffer: {
    real: 1,
    mock: 0
  }
};

const video = document.getElementById("video1");
const video1Loop = document.getElementById("video1Loop");
const videoNotTurning = document.getElementById("video1NotTurning");
const video1LoopNotTurning = document.getElementById("video1LoopNotTurning");
const video1LoopTraditionalCount = document.getElementById(
  "video1LoopTraditionalCount"
);
const video1LoopBufferCount = document.getElementById("video1LoopBufferCount");
const video1LoopTraditionalCountClass = document.getElementsByClassName(
  "video1LoopTraditionalCountNumber"
);
const video1LoopBufferCountClass = document.getElementsByClassName(
  "video1LoopBufferCountNumber"
);
const video1LoopCountRatio = document.getElementById("video1LoopCountRatio");
const video1LoopCountIncrement = document.getElementById(
  "video1LoopCountIncrement"
);
const video1LoopCountTimer = document.getElementById("video1LoopCountTimer");
const videoPasoAPaso = document.getElementById("pasoapaso");

var videoPasoAPasoStartTime = 0;
var videoPasoAPasoEndTime = 1;
var pasoApasoCurrentStep = 0;
var pasoapasoMarcador1 = document.getElementById("pasoapasoMarcador1");
var pasoapasoMarcador2 =  document.getElementById("pasoapasoMarcador2");

function videoPasoAPasoEventListener() {

  if(videoPasoAPaso.currentTime >= videoPasoAPasoEndTime) {
    videoPasoAPaso.pause();
    videoPasoAPaso.currentTime = videoPasoAPasoEndTime;
  }

  if(!videoPasoAPaso.paused) {
    requestAnimationFrame(videoPasoAPasoEventListener);
  }
}

videoPasoAPasoEventListener();

var pasoApasoTimes = {
  1: {
    "start": 0,
    "end": 1.35,
    "marcador1": 0,
    "marcador2": 0
  },
  2: {
    "start": 1.35,
    "end": 2.6,
    "marcador1": 1,
    "marcador2": 3
  },
  3: {
    "start": 2.6,
    "end": 4.05,
    "marcador1": 1,
    "marcador2": 3
  },
  4: {
    "start": 4.05,
    "end": 5.4,
    "marcador1": 2,
    "marcador2": 3
  },
  5: {
    "start": 5.4,
    "end": 6.7,
    "marcador1": 2,
    "marcador2": 3
  },
  6: {
    "start": 6.7,
    "end": 8,
    "marcador1": 3,
    "marcador2": 3
  }
}

window.pasoApaso = function(step) {
  if (step === "next") {
    pasoApasoCurrentStep++;
  } else {
    pasoApasoCurrentStep = step;
  }

  if (pasoApasoCurrentStep > 6) pasoApasoCurrentStep = 1;

  var time = pasoApasoTimes[pasoApasoCurrentStep]
  videoPasoAPasoStartTime = time.start;
  videoPasoAPasoEndTime = time.end;
  pasoapasoMarcador1.innerHTML = time.marcador1;
  pasoapasoMarcador2.innerHTML = time.marcador2;

  videoPasoAPaso.currentTime = videoPasoAPasoStartTime;

  var slides = document.getElementsByClassName("btnPaso");
  for (var i = 0; i < slides.length; i++) {
    slides.item(i).className = "btnPaso btn btn-outline-secondary w-auto text-center"
  }

  var elem = document.getElementById("btnPaso"+pasoApasoCurrentStep);
  elem.classList.remove("btn-outline-secondary");
  elem.classList.add("btn-warning");

  videoPasoAPaso.play();
  videoPasoAPasoEventListener();
}

const DEFAULT = "default";
const WOOD = "wood";

let selectedCrane = DEFAULT;
function changeCrane(button) {
  if (selectedCrane === DEFAULT) {
    changeVisibility("video1", "hidden");
    changeVisibility("onLoop", "hidden");
    button.style.backgroundImage = "url(assets/videos/bufferCraneDefault.jpg)";
    selectedCrane = WOOD;
  } else if (selectedCrane === WOOD) {
    changeVisibility("video1", "visible");
    changeVisibility("onLoop", initiated ? "visible" : "hidden");
    button.style.backgroundImage = "url(assets/videos/bufferCraneWood.jpg)";
    selectedCrane = DEFAULT;
  }
}

var counter = 3;
resituaDisplays();
changeVisibility("onLoop", "hidden");
video.play();
videoNotTurning.play();
setTimeout(init, 7500);

video.addEventListener(
  "ended",
  function () {
    video.style.display = "none";
    videoNotTurning.style.display = "none";

    if (turned) {
      video1Loop.style.display = "block";
    } else {
      video1LoopNotTurning.style.display = "block";
    }

    video1Loop.play();
    video1LoopNotTurning.play();

    video.removeAttribute('src');
    video.load();
    videoNotTurning.removeAttribute('src');
    videoNotTurning.load();

    updateCounters();
    introEnded = true;
  },
  false
);

video1Loop.addEventListener(
  "ended",
  function () {
    video1Loop.play();
    updateCounters();
  },
  false
);

video1LoopNotTurning.addEventListener(
  "ended",
  function () {
    video1LoopNotTurning.play();
  },
  false
);

function changeVisibility(clazz, visibility) {
  let display;
  if (visibility === "hidden") display = "none";
  if (visibility === "visible") display = "block";

  var appBanners = document.getElementsByClassName(clazz);
  for (var i = 0; i < appBanners.length; i++) {
    // appBanners[i].style.visibility = visibility;
    if (appBanners[i].tagName === "SPAN") {
      appBanners[i].style.visibility = visibility;
    } else {
      appBanners[i].style.display = display;
    }
  }
}

setInterval(setTime, 1000);

let initiated = false;
let reset = false;
let totalSeconds = 0;
let hours = "00";
let minutes = "00";
let seconds = "00";
let playing = true;
let turned = true;
let introEnded = false;

function pad(val) {
  var valString = val + "";
  if (valString.length < 2) {
    return "0" + valString;
  } else {
    return valString;
  }
}

function setTime() {
  if (reset) return;
  if (!playing) return;

  totalSeconds += 1 * (90 / 6);
  hours = pad(parseInt(totalSeconds / 3600));
  minutes = pad(parseInt(totalSeconds / 60) % 60);
  seconds = pad(totalSeconds % 60);
  video1LoopCountTimer.innerHTML = hours + ":" + minutes + ":" + seconds;
}

function init() {
  initiated = true;
  totalSeconds = 0;
  video1LoopCountTimer.innerHTML = "00:00:00";
  resituaDisplays();
  if (selectedCrane === DEFAULT) {
    changeVisibility("onLoop", "visible");
  }
  mockUpdateCounterBuffer();
}

function mockUpdateCounterBuffer() {
  if (reset) return;
  if (!playing) return;

  counter -= 1;

  counterRequest.buffer.mock += 1;

  updateCountersHTML();

  if (counter > 0) setTimeout(mockUpdateCounterBuffer, 2000);
}

function updateCounters() {
  if (!playing) return;

  if (reset) {
    resetCounters();
    reset = false;
  } else {
    counterRequest.traditional.real += 1;
    counterRequest.buffer.real += 3;

    counterRequest.traditional.mock = counterRequest.traditional.real;
    counterRequest.buffer.mock = counterRequest.buffer.real;
  }

  counter = 2;

  setTimeout(mockUpdateCounterBuffer, 2000);

  updateCountersHTML();
}

window.wantToPlayPause = function(elem) {
  if (playing) {
    if (introEnded) {
      video1Loop.pause();
      video1LoopNotTurning.pause();
    } else {
      videoNotTurning.pause();
      video.pause();
    }
    elem.innerHTML = `<i class="bi bi-play">`;
  } else {
    if (introEnded) {
      video1Loop.play();
      video1LoopNotTurning.play();
    } else {
      videoNotTurning.play();
      video.play();
    }
    elem.innerHTML = `<i class="bi bi-pause"></i>`;
  }

  playing = !playing;
}

window.wantToChangeTurned = function(elem) {
  if (turned) {
    if (introEnded) {
      video1LoopNotTurning.style.display = "block";
      video1Loop.style.display = "none";
    } else {
      videoNotTurning.style.display = "block";
      video.style.display = "none";
    }
    elem.innerHTML = `<i class="bi bi-arrow-clockwise"></i> Girar contenedor`
  } else {
    if (introEnded) {
      video1LoopNotTurning.style.display = "none";
      video1Loop.style.display = "block";
    } else {
      videoNotTurning.style.display = "none";
      video.style.display = "block";
    }
    elem.innerHTML = `<i class="bi bi-arrow-clockwise"></i><i class="bi bi-x"></i> No girar contenedor`
  }

  turned = !turned;
}

function updateCountersHTML() {
  for (var i = 0; i < video1LoopTraditionalCountClass.length; i++) {
    video1LoopTraditionalCountClass.item(i).innerHTML = counterRequest.traditional.mock;
  }

  for (var i = 0; i < video1LoopBufferCountClass.length; i++) {
    video1LoopBufferCountClass.item(i).innerHTML = counterRequest.buffer.mock;
  }

  if (counterRequest.traditional.mock != 0) {
    video1LoopCountRatio.innerHTML = (
      (counterRequest.buffer.mock / counterRequest.traditional.mock) *
      100
    ).toFixed(0);
    video1LoopCountIncrement.innerHTML =
      counterRequest.buffer.mock - counterRequest.traditional.mock;
  } else {
    video1LoopCountRatio.innerHTML = "100";
    video1LoopCountIncrement.innerHTML = "0";
  }
}

window.wantToReset = function() {
  counterRequest.traditional.mock = 0;
  counterRequest.buffer.mock = 0;

  counterRequest.traditional.real = 0;
  counterRequest.buffer.real = 0;

  hours = "00";
  minutes = "00";
  seconds = "00";
  video1LoopCountRatio.innerHTML = "100";
  video1LoopCountIncrement.innerHTML = "0";
  video1LoopCountTimer.innerHTML = "00:00:00";
  totalSeconds = 0;

  updateCountersHTML();

  reset = true;
}

function resetCounters() {
  counterRequest.traditional.mock = 1;
  counterRequest.buffer.mock = 1;

  counterRequest.traditional.real = 1;
  counterRequest.buffer.real = 1;

  hours = "00";
  minutes = "00";
  seconds = "00";
  video1LoopCountRatio.innerHTML = "100";
  video1LoopCountIncrement.innerHTML = "0";
  video1LoopCountTimer.innerHTML = "00:00:00";
  totalSeconds = 0;

  //TODO reiniciar video

  updateCountersHTML();
}
